import React from "react";

var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.53125 9.125C0.125 8.4375 0.125 7.59375 0.53125 6.875L3.28125 2.125C3.6875 1.40625 4.4375 1 5.21875 1H10.75C11.5625 1 12.2812 1.40625 12.6875 2.125L15.4375 6.875C15.8438 7.59375 15.8438 8.4375 15.4375 9.125L12.6875 13.9062C12.2812 14.625 11.5625 15.0312 10.75 15.0312H5.21875C4.4375 15.0312 3.6875 14.625 3.28125 13.9062L0.53125 9.125ZM8 4C7.5625 4 7.25 4.34375 7.25 4.75V8.25C7.25 8.6875 7.5625 9 8 9C8.40625 9 8.75 8.6875 8.75 8.25V4.75C8.75 4.34375 8.40625 4 8 4ZM9 11C9 10.4688 8.53125 10 8 10C7.4375 10 7 10.4688 7 11C7 11.5625 7.4375 12 8 12C8.53125 12 9 11.5625 9 11Z",
    fill: "#DC0A0A"
  }));
};

export default ErrorIcon;